import React from "react";
import { BodyText, VideoDeploymentContent } from "../../DeployShared";
import { WorkflowParameter } from "../../DeployCodeGenerators";

export type VideoLocalContentProps = {
    workflowUrl: string;
    workspaceUrl: string;
    apiKey: string | null;
    workflowParameters: WorkflowParameter[];
    isLocalEmbedded: boolean;
    workflowConfigJSON: string | null;
    isWorkflowEditor?: boolean;
};

export function VideoLocalContent({
    workflowUrl,
    workspaceUrl,
    apiKey,
    workflowParameters,
    isLocalEmbedded,
    workflowConfigJSON,
    isWorkflowEditor
}: VideoLocalContentProps) {
    if (isLocalEmbedded) {
        return (
            <div className="space-y-4 p-2">
                <BodyText>
                    Video processing on local embedded servers is currently under development. Check
                    the{" "}
                    <a
                        href="https://inference.roboflow.com/workflows/video_processing/overview/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        video processing docs
                    </a>{" "}
                    for updates. Your <code>workspace_name</code> should be set to{" "}
                    <code>local</code> and the <code>workflow_id</code> should be set to{" "}
                    <code>{workflowUrl}</code> when running via the SDK.
                </BodyText>
            </div>
        );
    }

    return (
        <VideoDeploymentContent
            workflowUrl={workflowUrl}
            workspaceUrl={workspaceUrl}
            apiKey={apiKey}
            workflowParameters={workflowParameters}
            isLocal={true}
            workflowConfigJSON={workflowConfigJSON}
            isWorkflowEditor={isWorkflowEditor}
        />
    );
}
